import React from 'react'
import classNames from 'classnames'
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser'
import Tippy from '@tippy.js/react'
import { NoMarkErrorComponent } from '../ValidatedInput/DefaultTooltipComponents'
import 'tippy.js/themes/light.css'

import styles from './termsCheckbox.module.scss'

const TermsCheckbox = React.forwardRef((props, ref) => {
  const {
    children,
    error,
    expand,
    position,
    message,
    anchorProps,
    onChange,
    clearErrors,
    clearErrorsOnClick,
    ...rest
  } = props
  const [visible, setVisible] = React.useState(Boolean(error))
  React.useEffect(() => {
    if (error) {
      setVisible(true)
    }
  }, [error])

  const handleChange = (event) => {
    setVisible(false)
    clearErrors(props.name)
    onChange && onChange(event)
  }

  return (
    <div
      className={classNames(styles.container, styles[position])}
      style={{ flexGrow: expand || 'inherit' }}
    >
      <div>
        <label style={{ position: 'absolute', left: 0, display: 'inline' }}>
          <input type='checkbox' ref={ref} {...rest} onChange={handleChange} />
          <Tippy
            visible={visible && Boolean(error)}
            placement='bottom'
            flip={false}
            hideOnClick={false}
            theme='light'
            zIndex={9}
            maxWidth='16.5rem'
            offset='300, 0'
            content={<NoMarkErrorComponent>{message}</NoMarkErrorComponent>}
            className={styles.text}
          >
            <span
              className={classNames(styles.checkmark, {
                [styles.checkmarkError]: visible && Boolean(error)
              })}
            />
          </Tippy>
        </label>
        <span>
          {ReactHtmlParser(children, {
            transform: (node, index) => {
              if (node.type === 'tag' && node.name === 'a') {
                const { onClick, ...restAnchorProps } = anchorProps || {}
                return (
                  <a
                    className={styles.anchor}
                    onClick={(event) => {
                      clearErrorsOnClick && clearErrors && clearErrors()
                      onClick && onClick(event)
                    }}
                    key={index}
                    {...restAnchorProps}
                  >
                    {node.children.map((n) => convertNodeToElement(n))}
                  </a>
                )
              }
            }
          })}
        </span>
      </div>
    </div>
  )
})

export default TermsCheckbox
